module.exports = __webpack_public_path__ + "static/img/12.5543841.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/12.png
// module id = 6qKb
// module chunks = 0